import React, { Component } from "react";
import {mapEthnicitySteps,uploadFileInstruction,mapType,reviewInstruction} from '../../../utils/constants';
import Steps from '../../Steps/Steps';
import UploadFile from '../Components/UploadFile/UploadFile';
import MatchColumns from '../Components/MatchColumns/MatchColumns';
import Review from '../Components/Review/Review';
import MapColumns from '../Components/MapColumns/MapColumns';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';
import remove from 'lodash/remove';
import findIndex from 'lodash/findIndex';
import flatten from 'lodash/flattenDeep';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import { deepClone } from "../../../utils/copyObject";
import axios from '../../../axios';
import * as url from '../../../utils/url';

export default class MapEthnicity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType : 'unmapped-first',
      ethnicityOptions : [],
      perMapping:[],
      error:false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let options 
    const orgID = this.props.user.organizationId._id
    console.log("COMPONENT DID MOUNT")
    console.log(this.props.mapEthnicity)
    axios.get(url.getMasterListByCategory('ETHNICITY')).then(({data}) => {
      console.log(data)
      const payload = data.data[0].docs;
      // console.log(payload)
       options = payload.map((i) => {
        const o = {};
        o.value = i._id;
        o.label = i.name;
        return o;
      });
      this.setState({
        ethnicityOptions : options
      })
    })
}

  handleFileUpload = (fields, data, file) => {
    const {matchedColumn} = this.props.mapEthnicity;
    
    // console.log("fields : ",fields,"includes : ",file, '--', data);
    if(matchedColumn.length > 0) {
      if(!fields.includes(matchedColumn)) {
        this.props.onMatchColumn("");
      }
    }
    this.props.onProcessedFileUploadData(fields, data, file);
    this.props.nextStep();
    // console.log("on handle file upload");
  }

  handleMapEthnicityContinue = () => {
    const prevMap = this.state.perMapping
    let err = this.state.error
    let {allEthnicityMapping} = this.props.mapEthnicity;
    const invalidRecords = filter(allEthnicityMapping,(o) => o.mapped && !o.column && o.column!=="");
    // console.log('invalid ---', invalidRecords)
    if(invalidRecords.length>0){
      this.setState({error:"Please map previously mapped values"})
      return
    } else {
      this.setState({error:false})
        this.props.nextStep()
    }
  }

  handleEthnicityMapped = (ethnicity,column) => {
    // console.log(performance,"--p---", column)
    const {allEthnicityMapping} = this.props.mapEthnicity;
    let allEthnicity = deepClone(allEthnicityMapping);
    const i = findIndex(allEthnicity,{value : ethnicity.value});
    allEthnicity.splice(i,1,{value:ethnicity.value,column:column, mapped:ethnicity.mapped})
    this.props.saveAllEthnicityMapping(allEthnicity);
  }

  handleMatchEthnicityColumn = (matchedColumn) => {
    let {rowData,allEthnicityMapping} = this.props.mapEthnicity;
    const {isRepeatFlow} = this.props;
    const uP = Object.keys(groupBy(rowData,(r) => r[matchedColumn]));
    const uniqueEthnicity = uP.filter(e => e!=="null")
    // console.log(uniquePerformance, isRepeatFlow);
    // console.log(allPerformanceMapping);
    this.props.onMatchColumn(matchedColumn);
    let options = this.state.ethnicityOptions
    const orgID = this.props.user.organizationId._id


    if(isRepeatFlow) {
      axios.get(url.getExistingMappings(orgID)).then(({data}) => {
        const payload = data.data;
        let {mapping} = payload;
        console.log('mppaing --- ', mapping)
        if(mapping.ethnicity && mapping.ethnicity.data ){
          allEthnicityMapping=[]
          console.log('opt---', options)
          mapping.ethnicity.data.map(e=>{
            let column = e.key
            let obj;
              e.values.map(c=>{
                console.log('e---',e)
                let cVal = find(options, {label:e.reference.name})
                console.log('va--', cVal)
                obj = {column:{value: cVal.value, label:e.reference.name}, value: c, mapped:true}
                return allEthnicityMapping.push(obj)
              })
          })
        console.log('all ---', allEthnicityMapping)
        this.props.saveAllEthnicityMapping(allEthnicityMapping)  

        if(allEthnicityMapping.length>0){
          const filteredMapping = uniqueEthnicity.map((f) => {
            const found = find(allEthnicityMapping,(o) => o.value === f);
            if(found) {
              return {
                value : f,
                column : found.column,
                mapped:true
              }
            } else {
              return {
                value : f,
                column : '',
                mapped:false
              }
            }
          })
         
           console.log(filteredMapping,'--',allEthnicityMapping);
           let results = allEthnicityMapping.concat(filteredMapping)
           let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
             console.log('mapping======>', e)
             if(e.column!==""){
               let obj = {
                 value:e.value,
                 mapped: e.mapped,
                 column: {label:e.column!==""?e.column.label:"",value: e.column?e.column.value:""}
               }
               return obj
             } else {
               let val = e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
               let obj = {
                 value:val,
                 mapped: false,
                 column: ""
               }
               return obj
             }
           })
           res = uniqBy(res, 'value')
           this.props.saveAllEthnicityMapping(res);
           this.props.nextStep();
        } else {
        this.props.saveAllEthnicityMapping(sortBy(filter(uniqueEthnicity,(p) => p != 'undefined').map((p) => {
          const g = {};
          g.value = p;
          g.column = ''
          return g;
        }),(o) => o.value));
        this.props.nextStep();
      }
    } else {
      this.props.saveAllEthnicityMapping(sortBy(filter(uniqueEthnicity,(p) => p != 'undefined').map((p) => {
        const g = {};
        g.value = p;
        g.column = ''
        return g;
      }),(o) => o.value));
      this.props.nextStep();
    }
    })
  }else {
    this.props.saveAllEthnicityMapping(sortBy(filter(uniqueEthnicity,(p) => p != 'undefined').map((p) => {
      const g = {};
      g.value = p;
      g.column = ''
      return g;
    }),(o) => o.value));
    this.props.nextStep();
  }
  

  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    })
  }

  handleContinue = () => {
    let {allEthnicityMapping} = this.props.mapEthnicity;
    const {isRepeatFlow} = this.props;
    allEthnicityMapping = filter(allEthnicityMapping,(m)=> m.column)
    // console.log('pp-----', allPerformanceMapping)
    const groupedMapping = groupBy(allEthnicityMapping,(m) =>  m.column.value);
    // console.log('g mapp 109 -- ' ,groupedMapping);
    let data = [];
    for(let key in groupedMapping) {
      // console.log(groupedMapping[key]);
      data.push({
        key : key,
        values : groupedMapping[key].map((o) => o.value)
      })
    }
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")
    // console.log(data);
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")

    const {matchedColumn} = this.props.mapEthnicity;
    // console.log(matchedColumn);
    const payload = {
      mappingType : "ethnicity",
      columnName : matchedColumn,
      data : data
    }
    console.log(payload);

    // return
    axios.post(url.saveMapping,payload).then(({data}) => {
      if(isRepeatFlow) {
        this.props.history.push({pathname : 'success',state : {type : 'ethnicity'}});
        this.props.reset();
      } else {
        this.props.history.push('/setup/map-separation');
      }
    })
  }

  handleonSortChange = (sortType) => {
    this.setState({
      sortType : sortType
    });
  }

  handleSkipStep = () => {
    axios.post(url.skipStepFor('ethnicity')).then(({data}) => {
      this.props.history.push('/setup/map-separation');
    })
  }

  render() {
    console.log(this.props);
    let {currentStep, allColumns, rowData, file, matchedColumn, 
      allEthnicityMapping} = this.props.mapEthnicity;
      // currentStep=currentStep?currentStep:0
      // console.log(this.props)
    const {searchedTerm,sortType,ethnicityOptions} = this.state;
    const {isRepeatFlow} = this.props;
    const existingMap = this.state.perMapping
    // console.log(ethnicityOptions)
    return (
      <div className={"mb30" + isRepeatFlow ? 'mt30' : 'mt70'}>
      <div className="map-performance-title mt30 mb30">Map Ethnicity/Race</div>
        <Steps steps={mapEthnicitySteps} currentStep={currentStep} />
        {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.mapEthnicity}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            type={mapType.ethnicity}
            labelSize={4}
            labelText="File with ethnicity/race information"
            allowedFileSize={20}
            uploadFileHint="(Only .csv files, maximum 20MB file size)"
            onFileUpload={this.handleFileUpload}
            onSkipStep={this.handleSkipStep}
            isRepeatFlow={isRepeatFlow}
          /> : 
          currentStep === 2 ?
            <MatchColumns
              goBack={this.props.goBack}
              top="mt40"
              instruction={`Please match the column with ethnicity/race information.`}
              csvFields = {allColumns}
              csvData = {rowData}
              type={mapType.ethnicity}
              mappingPositions={true}
              showDropdown={false}
              matchedColumns={matchedColumn!=="" ? [matchedColumn] : []}
              allowMoreColumnsMatch={false}
              nextBtnTxt='Continue'
              onMatchedColumn={this.handleMatchEthnicityColumn}
            /> : 
          currentStep === 3 ?
            <MapColumns
              allDataMapping={allEthnicityMapping}
              existingMap={existingMap}
              mapOptions={ethnicityOptions}
              onRowMapped={this.handleEthnicityMapped}
              nextStep={this.handleMapEthnicityContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              sortType={sortType}
              error={this.state.error}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              type={mapType.ethnicity}
              mapSelectPlaceholder="Map ethnicity/race"
              optionTypeTxt="Ethnicity/Race type"
              mappingTableHeader="Ethnicity/Race Name"
              searchBarPlaceholder="Search by ethnicity/race name..."
              mappingSubHeaderTxt="Please map your employees' ethnicity/race information to standardized categories."
            /> :
          currentStep === 4 ?
            <Review
              top="mt40"
              instruction={reviewInstruction.mapEthnicity}
              goBack={this.props.goBack}
              nextBtnAction={this.handleContinue}
              type={mapType.ethnicity}
              mapOptions={ethnicityOptions}
              file={file}
              nextBtnTxt={isRepeatFlow ? 'Finish' : 'Next Step'}
              isRepeatFlow={isRepeatFlow}
              reviewHeading="These are your final selections for the mapping. "
              {...this.props}/>
            :
            null
        }
    </div>
    );
  }
}